<template>
  <v-btn
    :class="`base-button text-none height-${heightVariant ?? 'lg'}`"
    v-bind="$attrs"
    elevation="0"
  >
    <div v-if="leftIcon" class="left-icon" :style="iconStyle">
      <v-img v-if="iconIsImage(leftIcon)" :src="leftIcon" :height="iconSize" :width="iconSize" />
      <v-icon v-else :size="iconSize" :icon="leftIcon" />
    </div>
    <slot />
    <div v-if="rightIcon" class="right-icon" :style="iconStyle">
      <v-img
        v-if="iconIsImage(rightIcon)"
        alt=""
        :src="rightIcon"
        :height="iconSize"
        :width="iconSize"
      />
      <v-icon v-else :size="iconSize" :icon="rightIcon" />
    </div>
  </v-btn>
</template>
<script setup lang="ts">
import { computed, useAttrs } from 'vue'
import { iconIsImage } from '@/utils/helpers'
import { VBtn } from 'vuetify/components'

type BUTTON_HEIGHT_VARIANTS = 'xl' | 'lg' | 'md' | 'sm' | 'xs' | 'auto'

defineProps<{
  iconSize?: string | number
  leftIcon?: string
  rightIcon?: string
  heightVariant?: BUTTON_HEIGHT_VARIANTS
}>()

// @ts-ignore
const attrs = useAttrs()

// @ts-ignore
const iconStyle = computed(() => {
  if (attrs['icon-gutter']) {
    return {
      margin: `0 ${attrs['icon-gutter']}px`
    }
  }
  return {}
})
</script>
